export enum DatePickerType {
    Year,
    Month,
    Full
}